import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import { MdEmail } from "react-icons/md";
import { RiLockPasswordFill } from "react-icons/ri";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { signInFirebase } from "../../Services/auth";
import { useDispatch } from "react-redux";
import LeadRubixLogo from "../../Assets/Images/leadrubixlogoone.svg";
import Cookies from "universal-cookie";
import AppStore from "../../Assets/Images/appstore.svg";
import PlayStore from "../../Assets/Images/playstore.svg";
import { Circles } from 'react-loader-spinner';
import { Box, Paper, Typography, Button, InputAdornment, IconButton, GlobalStyles } from "@mui/material";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";


type props = {
  history: any;
};

const CustomTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    borderRadius: 12,
    backgroundColor: "#f7f8fa",
    fontSize: "var(--font-size-large)",
    fontFamily: "var(--font-family-main)",
    "& fieldset": {
      borderColor: "#bfc7d5",
    },
    "&:hover fieldset": {
      borderColor: "#292744",
      border: `1.5px solid #292744`
    },
    "&.Mui-focused fieldset": {
      borderColor: "#292744",
      border: `1.5px solid #292744`
    },
  },
  "& .MuiInputBase-input": {
    padding: "14px",
    fontSize: 16,
    color: "#222",
  },
  "& .MuiInputLabel-root": {
    fontWeight: 500,
    fontSize: 15,
    color: "#292744",
  },
});

const SignIn: FunctionComponent<props> = ({ history }) => {
  const emailRef: any = useRef();
  const passwordRef: any = useRef();
  const dispatcher = useDispatch();
  const [load, setLoad] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [userProfileUid, setUserProfileUid] = useState<any>();
  const [showPassword, setShowPassword] = useState(false);
  const cookies = new Cookies();
  const expires = new Date();
  //Increse Expire time limit 30 Days 
  expires.setDate(expires.getDate() + 30);
  cookies.set("uId", userProfileUid, { expires });
  const changeLoad = (value: boolean) => {
    setLoad(value);
  };
  useEffect(() => {
    setShowLoader(false);
  }, [history]);
  useEffect(() => {
    setShowLoader(false);
  }, []);

  const login = async (email: string, password: string) => {
    localStorage.setItem("isLightMode", "true")
    setShowLoader(true);
    signInFirebase(
      email,
      password,
      history,
      dispatcher,
      setShowLoader,
      changeLoad,
      setUserProfileUid
    );
  };

  return (
    <>
      <GlobalStyles styles={{
        'input:-webkit-autofill, input:-webkit-autofill:focus, input:-webkit-autofill:hover, input:-webkit-autofill:active': {
          transition: 'background-color 9999s ease-in-out 0s',
          WebkitTextFillColor: '#222',
          boxShadow: '0 0 0 1000px #f7f8fa inset',
          backgroundColor: '#f7f8fa !important',
        }
      }} />
      <Box
        style={{
          minHeight: "100vh",
          width: "100vw",
          background: "linear-gradient(135deg, rgb(255,250,250) 0%, #e0e7ff 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "var(--font-family-main)",
        }}
      >
        <Paper
          sx={{
            width: 400,
            background: "#fff",
            borderRadius: 5,
            boxShadow: "0 8px 40px rgba(0,0,0,0.10)",
            padding: "32px 36px 36px 36px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            transition: "box-shadow 0.2s",
          }}
        >
          <img src={LeadRubixLogo} alt="LeadsRubix"
            style={{
              width: 170,
              marginBottom: 18,
            }} />
          <Typography
            variant="h5"
            sx={{
              fontFamily: "var(--font-family-main)",
              fontWeight: 700,
              fontSize: "var(--font-size-large)",
              mb: 1,
              color: "#292744",
              textAlign: "center",
            }}
          >
            Sign in to Leads Rubix
          </Typography>
          <form style={{ width: "100%", marginTop: 16 }} onSubmit={e => { e.preventDefault(); login(emailRef.current?.value, passwordRef.current?.value); }}>
            <Box sx={{ width: "100%", mb: 2 }}>
              <CustomTextField
                inputRef={emailRef}
                label="Email address"
                type="email"
                fullWidth
                required
                variant="outlined"
                placeholder="Enter email to get started"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <MdEmail style={{ color: "#9ca3af", fontSize: 20 }} />
                    </InputAdornment>
                  ),
                  style: { color: "#555", fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" }
                }}
                InputLabelProps={{ style: { color: "#555", fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" } }}
              />
            </Box>
            <Box sx={{ width: "100%", mb: 1 }}>
              <CustomTextField
                inputRef={passwordRef}
                label="Password"
                type={showPassword ? "text" : "password"}
                fullWidth
                required
                variant="outlined"
                placeholder="Enter your password"
                InputLabelProps={{ style: { color: "#555", fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <RiLockPasswordFill style={{ color: "#9ca3af", fontSize: 20 }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword((prev) => !prev)}
                        edge="end"
                        aria-label={showPassword ? "Hide password" : "Show password"}
                        tabIndex={0}
                        size="small"
                      >
                        {showPassword ? <AiOutlineEye /> : <AiOutlineEyeInvisible />}
                      </IconButton>
                    </InputAdornment>
                  ),
                  style: { color: "#555", fontFamily: "var(--font-family-main)", fontSize: "var(--font-size-medium)" }
                }}
                onKeyDown={e => {
                  if (e.key === "Enter") {
                    login(emailRef.current?.value, passwordRef.current?.value);
                  }
                }}
              />
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 0.5 }}>
                <span
                  style={{
                    color: "#292744",
                    fontSize: "var(--font-size-small)",
                    cursor: "pointer",
                    fontWeight: 500,
                    textDecoration: "underline"
                  }}
                  onClick={() => history.push("/forgetpassword")}
                >
                  Forgot password?
                </span>
              </Box>
            </Box>
          </form>
          <button
            style={{
              width: "100%",
              background: "linear-gradient(90deg, #292744 0%, #292744 100%)",
              color: "#fff",
              border: "none",
              borderRadius: 10,
              padding: "14px 0",
              fontSize: "var(--font-size-large)",
              marginTop: 16,
              marginBottom: 8,
              cursor: "pointer",
              boxShadow: "0 2px 8px rgba(41,39,68,0.10)",
              fontFamily: "var(--font-family-main)",
              transition: "background 0.2s, box-shadow 0.2s"
            }}
            onMouseOver={e => e.currentTarget.style.background = "linear-gradient(90deg, #292744 0%, #292744 100%)"}
            onMouseOut={e => e.currentTarget.style.background = "linear-gradient(90deg, #292744 0%, #292744 100%)"}
            onClick={() => login(emailRef.current?.value, passwordRef.current?.value)}
          >
            {showLoader ? (
              <span style={{ display: "flex", justifyContent: "center" }}>
                <Circles color="#fff" height={20} width={20} />
              </span>
            ) : (
              "Log in"
            )}
          </button>
          <div
            style={{
              marginBottom: 0,
              fontSize: "var(--font-size-medium)",
              color: "#555",
              textAlign: "center",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              whiteSpace: "nowrap",
              fontFamily: "var(--font-family-main)"
            }}
          >
            Don’t have an account?{" "}
            <span
              style={{
                color: "#292744",
                cursor: "pointer",
                marginLeft: 4,
                fontWeight: 500,
                textDecoration: "underline"
              }}
              onClick={() => history.push("/registrationForm")}
            >
              Create an account
            </span>
          </div>
          {/* App download icons */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 24,
              marginTop: 28,
              marginBottom: 4,
              width: "100%",
            }}
          >
            <div
              style={{
                background: "#e5e7eb",
                borderRadius: 32,
                width: 80,
                height: 56,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                cursor: "pointer"
              }}
              onClick={() => window.open("https://play.google.com/store/apps/details?id=com.leadsrubix&hl=en_IN", "_blank")}
              title="Get it on Google Play"
            >
              <img src={PlayStore} alt="Play Store" style={{ width: 36, height: 36 }} />
            </div>
            <div
              style={{
                background: "#e5e7eb",
                borderRadius: 32,
                width: 80,
                height: 56,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                cursor: "pointer"
              }}
              onClick={() => window.open("https://apps.apple.com/in/app/leads-rubix/id6471245646", "_blank")}
              title="Download on the App Store"
            >
              <img src={AppStore} alt="App Store" style={{ width: 36, height: 36 }} />
            </div>
          </div>
        </Paper>
      </Box>
    </>
  );
};

export default SignIn;